import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectMerchantList } from 'redux/app/merchant/merchant.selectors';
import { selectUserDetails } from 'redux/user/user.selectors';

export const useHasAccessToAssignedLocations = () => {
  const isClientAdmin = useSelector(selectUserDetails)?.isClientAdmin;
  const isWorkspaceAdmin = useSelector(selectUserDetails)?.isWorkspaceAdmin;
  const merchantList = useSelector(selectMerchantList);

  return useMemo(() => {
    return (
      !!isClientAdmin || (!!isWorkspaceAdmin && merchantList?.length === 1)
    );
  }, [isClientAdmin, isWorkspaceAdmin, merchantList?.length]);
};
